import { render } from "./CreateLab.vue?vue&type=template&id=0de638d2&scoped=true"
import script from "./CreateLab.vue?vue&type=script&lang=js"
export * from "./CreateLab.vue?vue&type=script&lang=js"

import "./CreateLab.vue?vue&type=style&index=0&id=0de638d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0de638d2"]])

export default __exports__